import React from 'react';
import ToolsMenu from '@/components/tools/ToolsMenu';
import DataModelReportTools from './DataModelReportTools';

const DataModelReportToolsMenu = ({
  code,
  downloadStart,
  isDownloading,
  report,
  upward,
}) => (
  <ToolsMenu upward={upward}>
    <DataModelReportTools code={code} downloadStart={downloadStart} isDownloading={isDownloading} report={report} />
  </ToolsMenu>
);
export default DataModelReportToolsMenu;
